export const CONSENT_STATUS_CHANGE = 'UC_CONSENT';
export const UC_UI_INITIALIZED = 'UC_UI_INITIALIZED';
export const GOOGLE_MAPS_NAME = 'Google Maps';
export const GOOGLE_PLACES_NAME = 'Google Maps Places';
export const GOOGLE_ANALYTICS_NAME = 'Google Analytics';
export const GOOGLE_TAG_MANAGER_NAME = 'Google Tag Manager';
export const GOOGLE_ADS_NAME = 'Google Ads';
export const GOOGLE_CUSTOMER_MATCH_NAME = 'Google Customer Match';
export const YOUTUBE_NAME = 'YouTube Video';
export const AKLAMIO_NAME = 'Aklamio';
export const DATADOG_RUM_NAME = 'Datadog Real User Monitoring';
export const HOTJAR_NAME = 'Hotjar';
export const FACEBOOK_NAME = 'Facebook Pixel';
export const LINKEDIN_NAME = 'LinkedIn Ads';
export const LEADFEEDER_NAME = 'Leadfeeder';

//# sourceMappingURL=ConsentManager.types.js.map